import api from "./api";

export interface SubscriptionInfo {
  subscription: {
    id: number;
    companyId: number;
    planId: number;
    status: number;
    trialStartsAt: string | null;
    trialEndsAt: string | null;
    currentPeriodEndsAt: string | null;
    canceledAt: string | null;
    createdAt: string;
    plan: {
      id: number;
      name: string;
      price: number;
      interval: number;
      isActive: boolean;
      maxCourts: number;
      description?: string;
      benefits?: string;
      isRecommended?: boolean;
    };
  };
  currentCourtCount: number;
  recommendedPlanId: number;
  recommendedPlanName: string;
  isPlanOptimal: boolean;
}

export interface RecommendedPlan {
  planId: number;
  planName: string;
  plan: {
    id: number;
    name: string;
    price: number;
    interval: number;
    isActive: boolean;
  };
  courtCount: number;
}

export interface AvailablePlan {
  id: number;
  name: string;
  price: number;
  interval: number;
  isActive: boolean;
  maxCourts: number;
  description: string;
  benefits: string[];
  isRecommended: boolean;
}

export const getCompanySubscription = async (
  companyId: number
): Promise<SubscriptionInfo | null> => {
  try {
    const response = await api.get<SubscriptionInfo>(
      `/Companies/${companyId}/subscription`
    );
    return response.data;
  } catch (error: any) {
    console.error("Erro ao obter assinatura:", error);
    return null;
  }
};

export const getRecommendedPlan = async (
  courtCount: number
): Promise<RecommendedPlan | null> => {
  try {
    const response = await api.get<RecommendedPlan>(
      `/Plans/recommended/${courtCount}`
    );
    return response.data;
  } catch (error: any) {
    console.error("Erro ao obter plano recomendado:", error);
    return null;
  }
};

export const updateSubscriptionPlan = async (
  companyId: number,
  courtCount: number
): Promise<boolean> => {
  try {
    await api.put(`/Plans/subscription/${companyId}/update-plan`, courtCount);
    return true;
  } catch (error: any) {
    console.error("Erro ao atualizar plano da assinatura:", error);
    return false;
  }
};

export const updateSubscriptionPlanById = async (
  companyId: number,
  planId: number
): Promise<boolean> => {
  try {
    await api.put(`/Plans/subscription/${companyId}/update-plan-by-id`, planId);
    return true;
  } catch (error: any) {
    console.error("Erro ao atualizar plano da assinatura por ID:", error);
    return false;
  }
};

export const getAvailablePlans = async (): Promise<AvailablePlan[]> => {
  try {
    const response = await api.get<AvailablePlan[]>("/Plans/available");
    return response.data;
  } catch (error: any) {
    console.error("Erro ao obter planos disponíveis:", error);
    return [];
  }
};
